
import React from 'react'
import dayjs from 'dayjs'
import { TextField, IconButton } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import useInvoiceBillStyles from '../styles'
import LogoP1 from '../../../../../assets/images/logomain.png'
import numberToWords from 'number-to-words'
import EditableDate from '../utils/EditableDate '

const OmDetailsPage = ({
  state,
  omAmounts,
  setOmAmounts,
  FetchCurrency,
  invoiceDate,
  firstDate,
  setFirstDate,
  invoiceDetails,
  handleEditClick,
  months,
  CurrentMonth,
  getCurrencyFullName,
  zohoState,
}) => {
  const classes = useInvoiceBillStyles()

  return (
    <div
      className={`${classes.containerNewStyle} print-no-border`}
      id="invoiceOM"
    >
      <div
        style={{
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <img style={{ height: 70, width: 150 }} src={LogoP1} alt="DE logo1" />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
                {zohoState?.organizationName || 'DE Solar Assets Series 2 LLP'}
              </div>
            </div>
        </div>
        <div
          style={{
            justifyContent: 'space-between',
            display: 'flex',
            flexDirection: 'row',
          }}
        >
          <div style={{ fontSize: '20px', color: 'gray' }}>
            Distributed Energy
          </div>
          <div style={{ fontSize: '20px', fontWeight: 'bold' }}>
            O&M INVOICE
          </div>
        </div>
      </div>

      <table className={`${classes.tableStyle} print-no-border`}>
        <tbody>
          <tr>
            <td>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div className={classes.tophstyle}>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ minWidth: '50%' }}>Invoice</div>
                    <div
                      md={4}
                      style={{ fontSize: '16px', fontWeight: 'bold' }}
                    >
                      : INV-{dayjs(invoiceDate).format('YYYYMM')}
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ minWidth: '50%' }}>Invoice Date</div>
                    <EditableDate
                      firstDate={firstDate}
                      setFirstDate={setFirstDate}
                      invoiceDetails={invoiceDetails}
                    />
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ minWidth: '50%' }}>Due Date</div>
                    <div
                      md={4}
                      style={{ fontSize: '16px', fontWeight: 'bold' }}
                    >
                      : {dayjs(firstDate).add(8, 'day').format('DD/MM/YYYY')}
                    </div>
                  </div>
                </div>
                <div className={classes.tophstyle}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ minWidth: '50%' }}>Plant Name </div>
                    <div
                      style={{
                        fontSize: '16px',
                        fontWeight: 'bold',
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      : {state?.data?.plantName}
                      <IconButton size="small" onClick={handleEditClick}>
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </div>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ minWidth: '50%' }}>Solar Plant Size</div>
                    <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
                      : ({state?.data?.plantSize}kWp)
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <div className={classes.tdStyle}>
                <div>
                  <div>Subject :</div>
                  <div>
                    O&M Charges for {months[CurrentMonth]}{' '}
                    {dayjs(invoiceDate).format('YYYY')}
                  </div>
                </div>
              </div>
            </td>
          </tr>

          <tr>
            <td>
              <table className={`${classes.tableStyle} print-no-border`}>
                <thead>
                  <tr>
                    <th className={classes.thStyle}>#</th>
                    <th className={classes.thStyle}>O&M Description</th>
                    <th className={classes.thStyle}>Tariff</th>
                    <th className={classes.thStyle}>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className={classes.tdStyle}>1</td>
                    <td className={classes.tdStyle}>
                      {state?.data?.plantName} O&M Charges
                    </td>
                    <td className={classes.tdStyle}>
                      <TextField
                        type="number"
                        value={omAmounts.toFixed(2)}
                        onChange={(e) =>
                          setOmAmounts(parseFloat(e.target.value || 0))
                        }
                        variant="standard"
                      />
                    </td>
                    <td className={classes.tdStyle}>{omAmounts.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>

          <tr>
            <td>
              <div style={{ display: 'flex', flexDirection: 'row' }}>
                <div className={classes.tophstyle}>
                  <div
                    className={classes.Boldstyle}
                    style={{
                      fontSize: '16px',
                      fontWeight: 'bold',
                      whiteSpace: 'initial',
                    }}
                  >
                    {getCurrencyFullName(state?.data?.currency)}{' '}
                    {numberToWords.toWords(Math.round(omAmounts || 0))} Total
                    Only
                  </div>

                  <div
                    style={{ fontSize: '16px', fontWeight: 'bold' }}
                    className={classes.Boldstyle}
                  >
                    CURRENT O&M OUTSTANDING BALANCE :{' '}
                    {FetchCurrency(state?.data?.currency)}{' '}
                    {(omAmounts || 0).toFixed(2)}
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    minWidth: '50%',
                    justifyContent: 'end',
                    border: '1px solid #dddddd',
                    padding: '8px',
                    textAlign: 'left',
                  }}
                >
                  <div style={{ minWidth: '25%' }}>
                    <div>O&M Charge</div>
                    <div
                      style={{ fontSize: '16px', fontWeight: 'bold' }}
                      className={classes.Boldstyle}
                    >
                      Total
                    </div>
                    <div
                      style={{ fontSize: '16px', fontWeight: 'bold' }}
                      className={classes.Boldstyle}
                    >
                      Balance Due
                    </div>
                  </div>
                  <div style={{ minWidth: '25%' }}>
                    <div>
                      : {FetchCurrency(state?.data?.currency)}{' '}
                      {(omAmounts || 0).toFixed(2)}
                    </div>
                    <div
                      style={{ fontSize: '16px', fontWeight: 'bold' }}
                      className={classes.Boldstyle}
                    >
                      : {FetchCurrency(state?.data?.currency)}{' '}
                      {(omAmounts || 0).toFixed(2)}
                    </div>
                    <div
                      style={{ fontSize: '16px', fontWeight: 'bold' }}
                      className={classes.Boldstyle}
                    >
                      : {FetchCurrency(state?.data?.currency)}{' '}
                      {(omAmounts || 0).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default OmDetailsPage
